import { Button, message, Typography } from "antd"
import { CopyOutlined } from "@ant-design/icons"
import dayjs from "dayjs"
import "./BitLockerKeys.scss"

const { Text } = Typography

const BitLockerKeys = ({ keys = [], mountPoint }) => {
  const list = (keys || []).filter((item) => {
    if (!mountPoint) return Boolean(item.recoveryPassword)
    return (
      String(item.mountPoint || "").replace(/\\+$/, "").toUpperCase() ===
      String(mountPoint).replace(/\\+$/, "").toUpperCase()
    )
  })

  if (!list.length) {
    return (
      <p className="bitlocker-keys__empty">
        No recovery key stored yet. Enable BitLocker from here to capture one.
      </p>
    )
  }

  const copy = async (value) => {
    try {
      await navigator.clipboard.writeText(value)
      message.success("Recovery key copied")
    } catch {
      message.error("Could not copy the recovery key")
    }
  }

  return (
    <div className="bitlocker-keys">
      {list.map((item, index) => (
        <div key={`${item.mountPoint}-${index}`} className="bitlocker-keys__row">
          <div>
            <Text strong>{item.mountPoint || mountPoint || "Drive"}</Text>
            <div className="bitlocker-keys__value">{item.recoveryPassword}</div>
            {item.capturedAt ? (
              <div className="bitlocker-keys__meta">
                Stored {dayjs(item.capturedAt).format("YYYY-MM-DD HH:mm")}
              </div>
            ) : null}
          </div>
          <Button
            size="small"
            icon={<CopyOutlined />}
            onClick={() => copy(item.recoveryPassword)}
          >
            Copy
          </Button>
        </div>
      ))}
    </div>
  )
}

export default BitLockerKeys
